import { vars, log } from './base/variables';
import { initMobileNavDropdown } from './functions/dropdown';
import { flyoutClass } from './functions/flyout-class';
import { menuToggle } from './functions/menu-toggle';
import { customSelect } from './functions/custom-select';
import { klaroAddBtn } from './functions/klaro';
import { initpostsFilters } from './components/posts-filters';
import { initYoutubePlayers, initHtmlPlayers } from './components/video-player';
import { tabDropdown } from './components/tabs-dropdown';
import { searchToggle } from './components/search-toggle';
import initSliders from './components/sliders';
import { animSections } from './components/animated-content';
import { initLightbox } from './components/simplelightbox';
import { goTopFunction } from './components/backtotop';

const menuBtn = document.getElementsByClassName('menu-toggle');
const isBlog = document.querySelector('body.blog .posts-container');
const ytplayers = document.querySelectorAll('.youtube-player');
const accordions = document.querySelectorAll('.accordion-item');
const toggle = document.getElementById('header-search-toggle');
const toggleNav = document.getElementById('header-search-toggle-nav');
const animSectionsWrappers = document.querySelectorAll(".text-teaser--animated-content");

////////////////////////////////////////////////
// Events
////////////////////////////////////////////////
document.addEventListener("DOMContentLoaded", () => {
    for (let index = 0; index < menuBtn.length; index++) {
        menuToggle(menuBtn[index], vars.body);
	}
	goTopFunction();
    initMobileNavDropdown();
    flyoutClass();
    initSliders();
    customSelect();
    initLightbox();
    ( animSectionsWrappers ) ? animSections( animSectionsWrappers ) : null;
    ( isBlog ) ? initpostsFilters( isBlog ) : null;
    ( ytplayers ) ? window.onYouTubeIframeAPIReady = ()=> { initYoutubePlayers(ytplayers); } : null;
    ( accordions ) ? tabDropdown( accordions ) : null;
    ( toggle ) ? searchToggle( toggle ) : null;
    ( toggleNav ) ? searchToggle( toggleNav ) : null;
    var klaroInit = 0;
    function checkKlaro() {
        setTimeout(() => {
            let btn = document.querySelector('#klaro .cm-btn.cm-btn-sm.cm-btn-success');
            if (btn) {
                klaroAddBtn(btn);
            } else {
                klaroInit++;
                if (klaroInit < 100) {
                    checkKlaro();
                }
            }
        }, 100);
    }
    checkKlaro();
});
